import { ErrorMessage } from '@eika/attention-message';
import React from 'react';

const ErrorSubmittingMessage = () => (
    <ErrorMessage
        className="form-submit-error-message"
        text="Beklager så mye, men noe gikk feil da vi skulle sende inn skjemaet. Vennligst prøv igjen senere."
    />
);

export default ErrorSubmittingMessage;
